module.exports = __webpack_public_path__ + "img/stonesettings.18b95a8.webp";